module.exports = __webpack_public_path__ + "img/Popup-Logo.dd81241.png";